import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
`;

export const Wrapper = styled.header`
  background-color: #fff;
  width: 100%;
`;
